<template>
  <b-modal
    header-class="modal-header--dialog"
    body-class="modal-body--dialog-form text-left"
    footer-class=""
    title="Job Docket Note"
    size="xl"
    hide-footer=""
    centered
    id="job-docket-note-modal"
    :busy="isLoading"
    @show="onShow"
  >
    <b-form>
      <b-form-group
        label="This note is printed on the job docket only. The customer will not see it."
        label-for="docket-note"
        class="mb-0"
      >
        <b-form-textarea
          id="docket-note"
          v-model="noteText"
          placeholder="Enter note"
          rows="3"
          max-rows="12"
          :maxlength="maxLength"
          :disabled="isLoading"
        ></b-form-textarea>
        <small class="text-muted">{{ (noteText || '').length }} / {{ maxLength }}</small>
      </b-form-group>
      <div class="mt-3">
        <b-button
          variant="primary"
          type="submit"
          @click.prevent="save"
          :disabled="isLoading || !noteText || !noteText.trim()"
        >
          {{ note ? 'Update' : 'Create' }}
        </b-button>
        <b-button
          v-if="note"
          variant="outline-danger"
          class="ml-2"
          @click.prevent="remove"
          :disabled="isLoading"
        >
          Delete
        </b-button>
      </div>
    </b-form>
    <div v-if="isLoading" class="text-center mt-3">
      <b-spinner />
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';
import apiNotes from '@/api/notes';
import apiOrders from '@/api/orders';

export const DOCKET_NOTE_PREFIX = 'Job Docket Note:';

export default {
  name: 'JobDocketNoteModal',
  data() {
    return {
      note: null,
      noteText: null,
      isLoading: false,
      maxLength: 500,
    };
  },
  computed: {
    ...mapState('commentModal', {
      selectedUpdateNote: state => state.selectedUpdateNote,
      selectedNoteOrder: state => state.selectedNoteOrder,
    }),
  },
  methods: {
    onShow() {
      if (this.selectedUpdateNote) {
        this.note = this.selectedUpdateNote;
        this.noteText = this.selectedUpdateNote.content.replace(DOCKET_NOTE_PREFIX, '').trim();
      } else {
        this.note = null;
        this.noteText = null;
      }
    },
    save() {
      const content = `${DOCKET_NOTE_PREFIX} ${this.noteText.trim()}`;
      const request = this.note
        ? apiNotes.updateOrderNoteDocket(this.selectedNoteOrder, this.note.id, { content })
        : apiNotes.createOrderNote(this.selectedNoteOrder, { content });

      this.finish(request, this.note ? 'Job Docket Note updated' : 'Job Docket Note created');
    },
    async remove() {
      const confirmed = await this.$dialog(
        'Delete Job Docket Note',
        ['Delete this note? It will no longer print on the job docket.'],
      );
      if (!confirmed) return;

      this.finish(
        apiNotes.deleteOrderNoteDocket(this.selectedNoteOrder, this.note.id),
        'Job Docket Note deleted',
      );
    },
    finish(request, message) {
      this.isLoading = true;
      request
        .then(() => apiOrders.getOrder(this.selectedNoteOrder))
        .then(({ data: { data: job } }) => {
          this.$store.commit('UPDATE_JOB_IN_JOBS', job);
          this.$bvModal.hide('job-docket-note-modal');
          this.$store.dispatch('showSuccessAlert', message);
        })
        .catch(e => {
          this.$store.dispatch(
            'showErrorAlert',
            (e.response && e.response.data && e.response.data.message) ||
              'Could not save the job docket note.',
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
